(function () {
  'use strict';

  var searchParams = new URLSearchParams(window.location.search);
  var query = (searchParams.get('q') || '').replace(/\*+$/, '');
  var selectedLocale = (document.querySelector('.ce-header__lang select[name="locale_code"]') || {}).value || '';
  var storedIntlMarket = '';
  try {
    storedIntlMarket = localStorage.getItem('ce_intl_poc_market') || '';
  } catch (error) {}
  var isEnglish = /^\/en(?:\/|$)/.test(window.location.pathname) ||
    ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0) ||
    ((window.Shopify && Shopify.locale || '').toLowerCase().indexOf('en') === 0) ||
    selectedLocale.toLowerCase().indexOf('en') === 0 ||
    storedIntlMarket.toUpperCase() === 'US';
  var compactPlaceholder = isEnglish ? 'Search by name, code, SKU, part number, or brand' : 'Busque por nome, código, SKU, part number ou marca';

  document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function (input) {
    if (input.id !== 'ce-collection-search') {
      input.setAttribute('placeholder', compactPlaceholder);
    }
    if (query && !input.value) input.value = query;
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', input.getAttribute('placeholder') || compactPlaceholder);
  });

  document.querySelectorAll('button, a, span, div').forEach(function (el) {
    if (el.childNodes.length === 1 && el.textContent.trim() === 'Compre por:') {
      el.textContent = isEnglish ? 'Categories and brands' : 'Categorias e marcas';
    }
  });

  document.querySelectorAll('a[href*="demo-gecko6.myshopify.com"]').forEach(function (link) {
    if (link.href.indexOf('/pages/store-location') !== -1) {
      link.href = 'https://www.google.com/maps/search/?api=1&query=Rua%20Am%C3%A9lia%20Pyramo%2030%20Belo%20Horizonte%20MG';
      link.target = '_blank';
      link.rel = 'noopener';
    } else {
      link.href = '/blogs/news';
    }
  });

  var isBrandPage = window.location.pathname.indexOf('/pages/marcas') !== -1 || !!document.querySelector('.caboeletro-brand-tools');

  document.querySelectorAll((isBrandPage ? 'a[href="#"]' : '.t4s-main-brand-page a[href="#"]')).forEach(function (link) {
    var label = link.textContent.trim();
    if (!label) {
      label = link.getAttribute('title') || link.getAttribute('aria-label') || '';
    }
    if (!label) {
      var img = link.querySelector('img[alt]');
      label = img ? img.getAttribute('alt') : '';
    }
    label = (label || '').replace(/_caboeletro/gi, '').replace(/[-_]/g, ' ').trim();
    if (!label) {
      link.removeAttribute('href');
      link.setAttribute('role', 'presentation');
      return;
    }
    link.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(label);
  });

  document.querySelectorAll('[data-caboeletro-collection-search]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      var scope = form.getAttribute('data-collection-term') || '';
      if (!input || !input.value.trim() || !scope) return;
      if (input.value.toLowerCase().indexOf(scope.toLowerCase()) === -1) {
        input.value = scope + ' ' + input.value.trim();
      }
    });
  });

  var brandSearch = document.querySelector('[data-caboeletro-brand-search]');
  if (brandSearch) {
    var brandScope = document.querySelector('.t4s-main-brand-page') || document.querySelector('#ecom-marcas') || document.querySelector('[id*="ecom-marcas"]') || document;
    var brandCards = Array.prototype.slice.call(document.querySelectorAll('[data-caboeletro-brand-card], .t4s-main-brand-page .t4s-filter-item'));
    if (!brandCards.length && brandScope) {
      brandCards = Array.prototype.slice.call(brandScope.querySelectorAll('.ecom-column, .ecom-block')).filter(function (card) {
        var label = card.textContent.trim();
        return label.length > 1 && label.length < 120 && (card.querySelector('a') || card.querySelector('img'));
      });
    }
    var filterBrands = function (term, startsWith) {
      var normalized = term.trim().toLowerCase();
      brandCards.forEach(function (card) {
        var text = card.textContent.trim().toLowerCase();
        var visible = !normalized || (startsWith ? text.charAt(0) === normalized : text.indexOf(normalized) !== -1);
        card.style.display = visible ? '' : 'none';
      });
      window.dispatchEvent(new Event('resize'));
    };

    brandSearch.addEventListener('input', function () {
      filterBrands(brandSearch.value, false);
    });

    document.querySelectorAll('[data-caboeletro-brand-letter]').forEach(function (button) {
      button.addEventListener('click', function () {
        var letter = button.getAttribute('data-caboeletro-brand-letter') || '';
        brandSearch.value = letter === 'all' ? '' : letter;
        filterBrands(brandSearch.value, letter !== 'all');
      });
    });
  }

  document.querySelectorAll('.t4s-product__description').forEach(function (description) {
    if (description.querySelector('.caboeletro-spec-table')) return;
    var raw = description.innerText || '';
    var rows = raw
      .split(/\n|•|;/)
      .map(function (line) { return line.trim(); })
      .filter(function (line) {
        return line.indexOf(':') > 0 && line.length < 160;
      })
      .slice(0, 10);

    if (rows.length < 2) return;

    var table = document.createElement('div');
    table.className = 'caboeletro-spec-table';
    table.setAttribute('aria-label', isEnglish ? 'Technical table' : 'Tabela técnica');

    rows.forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      var value = parts.join(':').trim();
      if (!key || !value) return;

      var row = document.createElement('div');
      row.className = 'caboeletro-spec-table__row';

      var keyEl = document.createElement('div');
      keyEl.className = 'caboeletro-spec-table__key';
      keyEl.textContent = key;

      var valueEl = document.createElement('div');
      valueEl.className = 'caboeletro-spec-table__value';
      valueEl.textContent = value;

      row.appendChild(keyEl);
      row.appendChild(valueEl);
      table.appendChild(row);
    });

    if (table.children.length >= 2) description.appendChild(table);
  });

  var ceHeader = document.querySelector('[data-ce-header]');
  if (ceHeader) {
    // The desktop header changes height by about 100px when condensed. Keep the
    // enter/exit thresholds farther apart than that, otherwise the browser's
    // scroll adjustment can cross the exit threshold and cause flicker.
    var ceCondensed = ceHeader.classList.contains('ce-header--condensed');
    var ceHeaderQueued = false;
    var ceHeaderThresholds = function () {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      return isMobile ? { enter: 160, exit: 80 } : { enter: 280, exit: 80 };
    };
    var ceApplyHeader = function () {
      ceHeaderQueued = false;
      var y = window.scrollY || window.pageYOffset || 0;
      var thresholds = ceHeaderThresholds();
      if (!ceCondensed && y > thresholds.enter) {
        ceCondensed = true;
        ceHeader.classList.add('ce-header--condensed');
      } else if (ceCondensed && y < thresholds.exit) {
        ceCondensed = false;
        ceHeader.classList.remove('ce-header--condensed');
      }
    };
    var ceUpdateHeader = function () {
      if (ceHeaderQueued) return;
      ceHeaderQueued = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(ceApplyHeader);
      } else {
        window.setTimeout(ceApplyHeader, 16);
      }
    };
    window.addEventListener('scroll', ceUpdateHeader, { passive: true });
    window.addEventListener('resize', ceUpdateHeader, { passive: true });
    ceUpdateHeader();
  }
})();
